document.addEventListener('DOMContentLoaded', () => {
    if (window.matchMedia("(min-width: 989px)").matches) {

    }

    gsap.set('.coFadeIn', { opacity: 0, y: 30 });
    ScrollTrigger.batch(".coFadeIn", {
        interval: 0,
        batchMax: 10,
        onEnter: batch => gsap.to(batch, {
            opacity: 1,
            y: 0,
            duration: 1.2,
            stagger: 0.2,
            delay: 0.2,
            ease: "power2.out",
        }),
    });

    gsap.set('.coFadeInMarquee', { opacity: 0, y: 50 });
    ScrollTrigger.batch(".coFadeInMarquee", {
        interval: 0,
        // batchMax: 20,
        onEnter: batch => gsap.to(batch, {
            opacity: 1,
            y: 0,
            duration: 1.2,
            stagger: 0.1,
            delay: 0.1,
            ease: "power2.out",
        }),
    });

    gsap.set('.coZoomDown', { opacity: 1, scale: 1.05 });
    ScrollTrigger.batch(".coZoomDown", {
        interval: 0,
        // batchMax: 20,
        onEnter: batch => gsap.to(batch, {
            opacity: 1,
            scale: 1,
            duration: 1.2,
            stagger: 0.2,
            delay: 0.1,
            ease: "power2.out",
        }),
    });
});